function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 9.57489,
  width: 9.5,
  height: 9.5,
  rx: 0.5,
  fill: "#49D1DF"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  width: 9.5,
  height: 9.5,
  rx: 0.5,
  fill: "#83E036"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 4,
  width: 9.5,
  height: 9.5,
  rx: 0.5,
  fill: "#FC5F5F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M41 15.0252C41.4949 17.7828 43.7811 19.3855 47.0101 19.3855C50.0741 19.3855 52.3838 17.6885 52.3838 14.8838C52.3838 12.6919 50.9461 11.3485 48.5892 10.8064L45.9495 10.1936C44.8653 9.93432 44.3232 9.43937 44.3232 8.61446C44.3232 7.57742 45.2424 6.91749 46.6094 6.91749C48.1178 6.91749 48.9427 7.6717 49.2727 8.63803H52.266C51.7946 6.18685 49.8855 4.44275 46.5858 4.44275C43.5454 4.44275 41.3771 6.28113 41.3771 8.89728C41.3771 11.2778 42.9798 12.3855 45.0539 12.8569L47.6464 13.4461C48.8956 13.7289 49.4141 14.2003 49.4141 15.0724C49.4141 16.2272 48.4478 16.8872 46.9865 16.8872C45.5724 16.8872 44.5118 16.2979 44.1111 15.0252H41Z",
  fill: "#3D414B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M54.9143 15.968C54.9143 18.3013 56.2578 19.3619 58.4026 19.3619C59.1803 19.3619 59.8874 19.2441 60.2881 19.0319V16.4394C59.9581 16.6515 59.4632 16.7929 59.0153 16.7929C58.2611 16.7929 57.8133 16.4158 57.8133 15.5909V10.9714H60.1231V8.61446H57.8133V5.76261H54.9143V8.61446H53.3117V10.9714H54.9143V15.968Z",
  fill: "#3D414B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M70.8915 19.1498V12.4326C70.8915 9.91075 69.2653 8.37877 66.4606 8.37877C64.0565 8.37877 62.336 9.84004 62.0296 11.7491H64.8107C65.0464 11.1363 65.5414 10.7592 66.3663 10.7592C67.5447 10.7592 68.0868 11.4899 68.0868 12.3855V13.1633C67.6626 12.8569 66.602 12.5505 65.6828 12.5505C63.3966 12.5505 61.6054 13.9175 61.6054 15.9208C61.6054 18.1128 63.3966 19.3383 65.5178 19.3383C66.6727 19.3383 67.7333 18.9377 68.0868 18.5841V19.1498H70.8915ZM68.0868 16.2744C67.8276 16.84 67.0262 17.1936 66.1777 17.1936C65.2585 17.1936 64.3158 16.8165 64.3158 15.8973C64.3158 15.0016 65.2585 14.601 66.1777 14.601C67.0262 14.601 67.8276 14.9545 68.0868 15.5202V16.2744Z",
  fill: "#3D414B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M73.2667 19.1498H76.1892V12.4798C76.4249 11.5606 77.2027 11.0185 78.0983 11.0185C79.2532 11.0185 79.8188 11.7727 79.8188 12.8804V19.1498H82.7414V12.2676C82.7414 9.93432 81.3979 8.37877 79.0175 8.37877C77.7919 8.37877 76.7549 8.92085 76.1892 9.58078V8.61446H73.2667V19.1498Z",
  fill: "#3D414B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M91.9305 19.1498H94.8766V3.82996H91.9305V9.48651C91.4591 8.92085 90.4221 8.37877 89.2908 8.37877C86.2268 8.37877 84.5063 10.8771 84.5063 13.8939C84.5063 16.9107 86.2268 19.3855 89.2908 19.3855C90.4221 19.3855 91.4591 18.8434 91.9305 18.2777V19.1498ZM91.9305 15.6144C91.6006 16.3451 90.8228 16.84 89.9507 16.84C88.3716 16.84 87.4288 15.5673 87.4288 13.8939C87.4288 12.1969 88.3716 10.9242 89.9507 10.9242C90.7992 10.9242 91.6006 11.4427 91.9305 12.1498V15.6144Z",
  fill: "#3D414B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M106.721 8.61446H103.775V15.308C103.563 16.2272 102.785 16.7693 101.89 16.7693C100.735 16.7693 100.193 16.0151 100.193 14.9074V8.61446H97.2702V15.4966C97.2702 17.8299 98.6136 19.3855 100.971 19.3855C102.196 19.3855 103.21 18.8434 103.799 18.1835V19.1498H106.721V8.61446Z",
  fill: "#3D414B"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M112.164 18.2777C112.635 18.8434 113.673 19.3855 114.804 19.3855C117.868 19.3855 119.612 16.8636 119.612 13.8939C119.612 10.9242 117.868 8.37877 114.804 8.37877C113.673 8.37877 112.635 8.92085 112.164 9.48651V8.61446H109.242V23.0387H112.164V18.2777ZM112.164 12.1498C112.518 11.4427 113.272 10.9242 114.144 10.9242C115.723 10.9242 116.666 12.1969 116.666 13.8939C116.666 15.5673 115.723 16.84 114.144 16.84C113.295 16.84 112.518 16.3451 112.164 15.6144V12.1498Z",
  fill: "#3D414B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M121.463 19.1498H124.386V12.4798C124.622 11.5606 125.399 11.0185 126.295 11.0185C127.45 11.0185 128.016 11.7727 128.016 12.8804V19.1498H130.938V12.2676C130.938 9.93432 129.595 8.37877 127.214 8.37877C125.989 8.37877 124.952 8.92085 124.386 9.58078V3.82996H121.463V19.1498Z",
  fill: "#3D414B"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M142.696 8.61446H139.75V15.308C139.538 16.2272 138.76 16.7693 137.865 16.7693C136.71 16.7693 136.168 16.0151 136.168 14.9074V8.61446H133.245V15.4966C133.245 17.8299 134.588 19.3855 136.945 19.3855C138.171 19.3855 139.184 18.8434 139.774 18.1835V19.1498H142.696V8.61446Z",
  fill: "#3D414B"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M148.139 18.2777C148.61 18.8434 149.647 19.3855 150.779 19.3855C153.843 19.3855 155.563 16.9107 155.563 13.8939C155.563 10.8771 153.843 8.37877 150.779 8.37877C149.647 8.37877 148.61 8.92085 148.139 9.48651V3.82996H145.193V19.1498H148.139V18.2777ZM148.139 12.1498C148.469 11.4427 149.27 10.9242 150.119 10.9242C151.698 10.9242 152.641 12.1969 152.641 13.8939C152.641 15.5673 151.698 16.84 150.119 16.84C149.247 16.84 148.469 16.3451 148.139 15.6144V12.1498Z",
  fill: "#3D414B"
});

var SvgStanduphubLogo = function SvgStanduphubLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 24,
    viewBox: "0 0 156 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStanduphubLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/standuphub-logo.82de2db6.svg";
export { ForwardRef as ReactComponent };